import { faUpload, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Form, FormControl } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { API, fileUpload } from "../../../../config";
import { toast } from "react-toastify";
import CustomTooltip from "../../../common/CustomTooltip";
import ContractorSelectWithTA from "../../../common/ContractorSelectWithTA";
import { getContractorDetail } from "../../sub-contractors/components/SubContractorHelper";

const defaultOption = [
  { label: "Copy Of Contracts", value: 1 },
  { label: "Any Contract Variation/Amendment Documents", value: 2 },
  { label: "Payment Claims/ Schedules Given And Received", value: 3 },
  { label: "Supporting Documents", value: 4 },
  { label: "Others", value: 5 },
];

const newEntryData = { document_type: "", documents: [] };

const arrayRemove = (arr, value) => {
  if (value) {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  }
};

const Upload = () => {
  const navigate = useNavigate();
  const params = useParams();
  const projectId = params?.project_id;
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);

  const [Option, setOption] = useState(defaultOption);
  const [finalData, setFinalData] = useState([newEntryData]);
  const [contractorDetails, setContractorDetails] = useState();
  const [disableState, setDisableState] = useState(false);

  useEffect(() => {
    // navigate(`/projects/${projectId}/settings?tab=documents&child_tab=upload`, {
    //   replace: true,
    // });
    navigate(`/projects/${projectId}/documents?tab=documents&child_tab=list`, {
      replace: true,
    });
  }, [projectId, navigate]);

  useEffect(() => {
    finalData &&
      finalData?.length > 0 &&
      finalData?.map((item, index) => {
        const documentType = item?.document_type
          ? Option?.find((option) => option === item?.document_type)
          : "";
        documentType && setOption(arrayRemove(Option, documentType));
        return 0;
      });
  }, [finalData, Option]);

  const handleSelectChange = (finalData, finalIndex, e, documentType) => {
    const newArr = finalData.map((obj, i) => {
      if (i === finalIndex) {
        return {
          ...obj,
          document_type: e ? e : "",
        };
      }
      return obj;
    });

    documentType && setOption([...Option, documentType]);
    setFinalData(newArr);
  };

  // const handleDocumentChange = (data, finalIndex, file) => {
  //   // const newDocuments = [...data[finalIndex].documents, file];
  //   let newData = [...data];

  //   if (finalIndex > -1) {
  //     newData[finalIndex] = {
  //       ...newData[finalIndex],
  //       documents: [file],
  //     };
  //     setFinalData([...newData]);
  //   }
  // };

  // const handleDocumentDelete = (finalData, finalIndex, index) => {
  //   finalData[finalIndex]?.documents.splice(index, 1);

  //   const newDocuments = [...finalData[finalIndex].documents];
  //   let newData = [...finalData];

  //   if (finalIndex > -1) {
  //     newData[finalIndex] = {
  //       ...newData[finalIndex],
  //       documents: newDocuments,
  //     };
  //     setFinalData([...newData]);
  //   }
  // };

  const handleDocumentDelete = (finalData, finalIndex, index) => {
    let newData = [...finalData];

    if (finalIndex > -1) {
      const newDocuments = newData[finalIndex]?.documents.filter(
        (_, docIndex) => docIndex !== index
      );

      newData[finalIndex] = {
        ...newData[finalIndex],
        documents: newDocuments,
      };

      setFinalData([...newData]);
    }
  };

  const handleFinalDelete = (finalData, finalIndex, finalItem) => {
    finalItem?.document_type &&
      setOption([...Option, finalItem?.document_type]);
    finalData.splice(finalIndex, 1);
    setFinalData([...finalData]);
  };

  // const handleAdd = () => {
  //   setFinalData([...finalData, newEntryData]);
  // };

  const handleSubmit = async () => {
    try {
      const formData = new FormData();
      formData.append("builder_project_id", projectId ? projectId : "");
      formData.append(
        `contact_id`,
        contractorDetails?.id ? contractorDetails?.id : ""
      );
      formData.append(
        "document_type",
        finalData[0]?.document_type?.value
          ? finalData[0]?.document_type?.value
          : ""
      );
      formData.append(
        "document",
        finalData[0]?.documents ? finalData[0]?.documents[0] : ""
      );
      setLoading(true);
      const { data } = await fileUpload(`${API.UPLOAD_DOCUMENT}`, formData);
      if (data) {
        setLoading(false);
        setFinalData([newEntryData]);
        toast.success(data.message);
        navigate(
          `/projects/${projectId}/settings?tab=documents&child_tab=list`,
          {
            replace: true,
          }
        );
      }
    } catch (error) {
      //   setProjectData(value);
      // setShowAccount(false);
      setLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  const getContractor = async (contractorId) => {
    try {
      setLoading(true);
      const data = await getContractorDetail(contractorId);
      const contractorData = data ? data : {};
      if (contractorData?.id) {
        if (
          contractorData?.account_name &&
          contractorData?.account_number &&
          contractorData?.bsb
        ) {
          setDisableState(true);
        } else {
          setDisableState(false);
          toast.error("Please add bank details of selected contractor.");
        }
      }
      setLoading(false);
    } catch (e) {
      setDisableState(false);
      toast.error("Something went wrong.");
    }
  };

  const handleContractorSelect = async (contractor) => {
    setContractorDetails(contractor);
    getContractor(contractor?.id, contractor);
  };
  

  return (
    <div className="documents-tab">
      <div className="documents-upload row">
        {finalData &&
          finalData?.length > 0 &&
          finalData?.map((finalItem, finalIndex) => {
            return (
              <>
                <div className="documents-upload-content col-md-6">
                  {finalData?.length > 1 && (
                    <div className="upload-header">
                      <FontAwesomeIcon
                        icon={faTrash}
                        onClick={() => {
                          handleFinalDelete(finalData, finalIndex, finalItem);
                        }}
                      />
                    </div>
                  )}
                  <div className="docs-input-select contact-select">
                    <ContractorSelectWithTA
                      regionName={"0"}
                      projectId={projectId}
                      value={contractorDetails ? contractorDetails : null}
                      onChange={(contractor) => {
                        handleContractorSelect(contractor);
                      }}
                      business={true}
                      className="contactname-select selectbox"
                      placeholder="Select Subcontractor"
                      isClearable={false}
                    />
                    {!disableState && contractorDetails && (
                      <div className="bank-details">
                        <p className="text-danger">
                          {/* Subcontractor does not have bank details */}
                          <Link
                            to={{
                              pathname: `/projects/${projectId}/sub-contractors/edit/${contractorDetails?.id}`,
                            }}
                            className="update-bank-text"
                          >
                            Update bank details
                          </Link>
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="docs-input-select">
                    <Select
                      options={Option}
                      onChange={(e) => {
                        handleSelectChange(
                          finalData,
                          finalIndex,
                          e,
                          finalItem?.document_type
                        );
                      }}
                      value={
                        finalItem?.document_type ? finalItem?.document_type : ""
                      }
                      classNamePrefix="selectbox"
                    />
                  </div>
                  <div>
                    <div className="upload-div">
                      <label>Document Upload</label>

                      <div className="modal-body">
                        <Form>
                          <div className="upload-file">
                            <FormControl
                              accept={
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, image/jpeg, image/jpg, image/x-png, .doc, .docx, .pdf"
                              }
                              type="file"
                              name="documents"
                              className="form-control"
                              id="documents"
                              multiple
                              onChange={(e) => {
                                const files = Array.from(e.currentTarget.files);
                                const allowedTypes = [
                                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                  "application/vnd.ms-excel",
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                  "application/msword",
                                  "application/pdf",
                                ];

                                const validFiles = files.filter((file) =>
                                  allowedTypes.includes(file.type)
                                );
                                let newData = [...finalData];

                                if (validFiles.length > 0) {
                                  validFiles.forEach((file) => {
                                    if (finalIndex > -1) {
                                      newData[finalIndex] = {
                                        ...newData[finalIndex],
                                        documents: [
                                          ...(newData[finalIndex].documents ||
                                            []),
                                          file,
                                        ],
                                      };
                                    }
                                  });
                                } else {
                                  toast.error(
                                    "Please upload .pdf, .doc, .docx, .xls, .xlsx, .jpeg, .jpg, or .png only."
                                  );
                                }
                                setFinalData([...newData]);
                              }}
                            />
                            <span>
                              <p className="ant-upload-drag-icon">
                                <FontAwesomeIcon icon={faUpload} size="3x" />
                              </p>
                              <p className="ant-upload-text">
                                Click or drag file to this area to upload
                              </p>
                            </span>
                          </div>
                          <div>
                            <label>Document List</label>
                            {finalItem?.documents &&
                              finalItem?.documents?.length > 0 &&
                              finalItem?.documents?.map((item, index) => {
                                return (
                                  <div className="file-names">
                                    <p>{`${item?.name}`}</p>
                                    <div className="remove">
                                      <CustomTooltip message={"Remove"}>
                                        <span>
                                          <FontAwesomeIcon
                                            icon={faTrash}
                                            onClick={() => {
                                              handleDocumentDelete(
                                                finalData,
                                                finalIndex,
                                                index
                                              );
                                            }}
                                          />
                                        </span>
                                      </CustomTooltip>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        {/* {finalData && finalData?.length < 5 && (
          <div className="add-button">
            <div className="add-document-card">
              <FontAwesomeIcon
                icon={faPlus}
                size="9x"
                onClick={() => {
                  handleAdd();
                }}
              />
            </div>
          </div>
        )} */}
      </div>
      <div className="footer">
        <Button onClick={handleSubmit} disabled={!disableState}>
          Save
        </Button>
      </div>
    </div>
  );
};
export default Upload;
